import {
  archiveMission,
  deleteClient,
} from "../../../services/Api/customerService";
import {
  reactivateCustomer,
  reactiveMission,
} from "../../../services/Api/adminService";
import { useLocation, useParams } from "react-router-dom";
import { useServiceStore } from "../../../stores/admin/service";
import {
  showToastError,
  showToastSuccess,
} from "../../../services/Toasts/toasts";

const ArchiveDeleteFile = ({ id, closeModal, closed, idCustomer }: any) => {
  const location = useLocation();
  const { update, setUpdate } = useServiceStore();
  const { idPartner } = useParams();

  const handleArchive = async (id: number) => {
    const success = location.pathname.includes("clientfile")
      ? await deleteClient(id)
      : await archiveMission(Number(idCustomer), id);
    if (success) {
      setUpdate(!update);
      closeModal();
      showToastSuccess("L'archivage a bien été effectué !");
    } else {
      closeModal();
      showToastError("La suppression a échoué !");
    }
  };

  const handleReactivate = async (id: number) => {
    const success = location.pathname.includes("clientfile")
      ? await reactivateCustomer(Number(idPartner), id)
      : await reactiveMission(Number(idPartner), id);
    if (success) {
      showToastSuccess("La désarchivage a bien été effectué !");
      setUpdate(!update);
      closeModal();
    } else {
      closeModal();
      showToastError("La suppression a échoué !");
    }
  };

  return (
    <>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-hidden focus:outline-hidden">
        <div className="relative w-auto md:w-1/4 my-6 mx-auto max-w-3xl min-w-[65%]">
          {/* Content */}
          <div className="border-0 rounded-xl shadow-lg relative flex flex-col w-full bg-white outline-hidden focus:outline-hidden">
            {/* Header */}
            <div className="w-full bg-white p-3 rounded-t-xl">
              <h4 className="text-xl font-semibold text-gray-700 mb-3 flex items-center gap-2">
                {closed === 1 ? (
                  <svg className="w-5 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                  </svg>
                ) : (
                  <svg className="w-5 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.375 7.5m8.25 3v6.75m0 0l-3-3m3 3l3-3M3.375 7.5h13.5c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z" />
                  </svg>
                )}
                {closed === 1 ? "Réactivation" : "Archivage"}
              </h4>
            </div>
            {/* Body */}
            <div className="w-full flex flex-col items-center justify-center text-grey-trio">
              <div className="flex flex-col justify-center items-center w-11/12 mb-6">
                <div className={`w-16 h-16 rounded-full flex items-center justify-center mb-4 ${
                  closed === 1 ? "bg-green-100" : "bg-blue-100"
                }`}>
                  {closed === 1 ? (
                    <svg className="w-8 h-8 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                    </svg>
                  ) : (
                    <svg className="w-8 h-8 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.375 7.5m8.25 3v6.75m0 0l-3-3m3 3l3-3M3.375 7.5h13.5c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z" />
                    </svg>
                  )}
                </div>
                <h3 className="text-lg font-semibold text-gray-700 mb-2 text-center">
                  {closed === 1 ? "Confirmation de réactivation" : "Confirmation d'archivage"}
                </h3>
                <p className="text-md text-gray-600 text-center mb-4">
                  {closed === 1
                    ? "Ce dossier est déjà archivé. Vous pouvez le réactiver. Êtes-vous sûr de bien vouloir le réactiver ?"
                    : "Êtes-vous sûr de bien vouloir archiver ce dossier ?"}
                </p>
                <p className="text-sm text-gray-500 text-center mt-3 italic">
                  {closed === 1 
                    ? "Cette action réactivera le dossier."
                    : "Cette action archivera définitivement le dossier."
                  }
                </p>
              </div>
            </div>

            {/* Footer */}
            <div className="flex items-center justify-end p-3 rounded-b-2xl bg-white gap-3">
              <button
                className="px-4 py-2 bg-gray-100 text-gray-500 hover:bg-gray-200 cursor-pointer font-semibold rounded-xl transition-all duration-200 flex items-center gap-2 text-sm"
                type="button"
                onClick={() => closeModal()}
              >
                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
                Annuler
              </button>
              <button
                className={`px-4 py-2 cursor-pointer text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 flex items-center gap-2 text-sm ${
                  closed === 1 
                    ? "bg-green-600 hover:bg-green-700" 
                    : "bg-blue-600 hover:bg-blue-700"
                }`}
                type="button"
                onClick={() => {
                  if (closed === 1) {
                    handleReactivate(id);
                    setTimeout(() => {
                      closeModal();
                    }, 2300);
                  } else {
                    handleArchive(id);
                    setTimeout(() => {
                      closeModal();
                    }, 2300);
                  }
                }}
              >
                {closed === 1 ? (
                  <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                  </svg>
                ) : (
                  <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.375 7.5m8.25 3v6.75m0 0l-3-3m3 3l3-3M3.375 7.5h13.5c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z" />
                  </svg>
                )}
                {closed === 1 ? "Réactiver" : "Archiver"}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
    </>
  );
};

export default ArchiveDeleteFile;
